export default "__VITE_ASSET__Z7dyLSSK__"